export const MAX_LENGTH_GROUP_NAME = 50;
